<template>
    <v-dialog-old ref="dialog" id="passportCancelDialog">
        <form>
            <fieldset width="600">
                <legend>Причина отклонения</legend>
                <form>
                    <label>
                        <input type="radio" v-model="cancelReasonDefault" value="ФИО в анкете/дипломе не соответствуют паспорту">
                        <span>ФИО в анкете/дипломе не соответствуют паспорту</span>
                    </label>
                    <label>
                        <input type="radio" v-model="cancelReasonDefault" value="Введённые данные не соответствуют паспорту">
                        <span>Введённые данные не соответствуют паспорту</span>
                    </label>
                    <label>
                        <input type="radio" v-model="cancelReasonDefault" value="Другое">
                        <span>Другая причина</span>
                    </label>
                    <textarea v-model="cancelReason" :disabled="cancelReasonDefault !== 'Другое'"/>
                </form>
            </fieldset>
            <footer>
                <v-loading-component @click="submit">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green', loadingClass]" :disabled="!cancelReasonDefault">Отказать</button>
                    </template>
                </v-loading-component>
            </footer>
        </form>
    </v-dialog-old>
</template>
<script>
export default {
    data(){
        return{
            cancelReasonDefault: '',
            cancelReason: '',
            passportDetailsId: null,
        }
    },
    methods:{
        resetData() {
            this.cancelReasonDefault = '';
            this.cancelReason = '';
        },
        show(data) {
            this.resetData();

            this.passportDetailsId = data.passportDetailsId;

            this.$refs.dialog.show();
        },
        submit(btn) {
            if (!this.cancelReasonDefault) {
                return;
            }
            btn.startLoadingAnimation();

            this.axios.post('passportDetails/cancel/'+this.passportDetailsId, {
                cancelReason: this.cancelReasonDefault === 'Другое' ? this.cancelReason : this.cancelReasonDefault
            }).then(response => {
                btn.stopLoadingAnimation();

                this.$emit('canceled');
                this.$refs.dialog.hide();
            }).catch(() => btn.stopLoadingAnimation());
        }
    }
}
</script>
<style>
#passportCancelDialog {
    width: 705px;
}
</style>
